module.exports = __webpack_public_path__ + "img/icon-question-color.1d5fefe8.svg";